/* eslint-disable */
import React, { useEffect } from "react";
import { Grid, Typography, RACModalCard, RACButton } from "@rentacenter/racstrap";
import { StoreExceptionType } from "../../constants/constants";
import { useTranslation } from 'react-i18next';

// import { storeException } from "../../api/user";
import { CustomerdataContext } from "../../context/customer/customerdata";

interface storeExceptionInterFace {
    refCode?: any;
    identifierId?: any;
    storeExceptionCancelled?: any
    storeExceptionCompleted?: any
    identifierType?: any
    isopen?: any
    setStoreExceptionEnable?: any
    exceptionDescscription?: any

}
export default function StoreException(props: storeExceptionInterFace) {
    const {t,i18n}=useTranslation("Offers")
    const language: any = window.sessionStorage.getItem('language')
    let { StoreExceptionPayload, setStoreExceptionPayload } = React.useContext(CustomerdataContext)
    const { refCode, identifierId, storeExceptionCancelled, storeExceptionCompleted, identifierType, exceptionDescscription } = props

    const [storeExceptionPopup, setStoreExceptionPopup] = React.useState(true)
    let [exceptionText, SetexceptionText] = React.useState('')
    let [remainingLength, setremainingLength] = React.useState(255)
    let [exceptionDesc, setexceptionDesc] = React.useState('')

    useEffect(() => {
        const exceptionDescription = StoreExceptionType.filter((obj: any) => obj.abbreviation == refCode)
        exceptionDesc = t(exceptionDescription[0].description)
        setexceptionDesc(exceptionDesc)
    }, [props.isopen])

    const exceptionTextEnterFn = (inputText: any) => {
        exceptionText = inputText
        SetexceptionText(inputText)

        remainingLength = 255 - exceptionText.length
        setremainingLength(remainingLength)


    }
    const setStoreExceptionCancelClick = async () => {


        if (props.isopen == true || props.isopen == false) {
            props.setStoreExceptionEnable(false)
        }
        else {
            setStoreExceptionPopup(false)

        }
        storeExceptionCancelled()
        exceptionText = ''
        SetexceptionText(exceptionText)
        exceptionDesc = ''
        setexceptionDesc(exceptionDesc)
        remainingLength = 255
        setremainingLength(remainingLength)
    }
    const setStoreExceptionCompletedClick = async () => {
        debugger


        if (props.isopen == true || props.isopen == false) {
            props.setStoreExceptionEnable(false)
        }
        else {
            setStoreExceptionPopup(false)

        } const payload = [

            {
                identifierType: identifierType,
                storeNumber: window.sessionStorage.getItem('storeNumber'),
                exceptionTypeRefCode: refCode,
                exceptionText: exceptionText
            }


        ]
        const updatedPayload = [...StoreExceptionPayload, ...payload]
        StoreExceptionPayload = updatedPayload
        setStoreExceptionPayload(StoreExceptionPayload)


        storeExceptionCompleted(updatedPayload)
        exceptionText = ''
        SetexceptionText(exceptionText)
        exceptionDesc = ''
        setexceptionDesc(exceptionDesc)
        remainingLength = 255
        setremainingLength(remainingLength)

    }
    const StoreExceptionPopup = () => {
        return (
            <>
                <Typography style={{ marginTop: '10px' }}>
                    {t('Explanation')} <span style={{ color: 'red' }}> *</span>
                </Typography>
                <textarea
                    value={exceptionText}
                    rows={8}
                    cols={73}
                    maxLength={255}
                    onChange={(e: any) => {
                        exceptionTextEnterFn(e.target.value.trimStart())

                    }}
                    style={{ resize: 'none', borderRadius: '5px', marginTop: '5px', padding: '5px' }}
                >

                </textarea>
                <span style={{ marginTop: '15px', fontFamily: 'OpenSans-semibold', color: '#00000085' }}>{remainingLength}/255 {t('characters left')}.</span>
                <Grid style={{ float: 'right', marginTop: '34px' }}>
                    <RACButton
                        style={{ marginRight: '10px' }}
                        color='default'
                        variant='outlined'
                        disabled={false}
                        onClick={() => setStoreExceptionCancelClick()}
                    >
                        {t('Cancel')}
                    </RACButton>
                    <RACButton
                        style={{ marginRight: '35px' }}
                        color='primary'
                        variant='contained'
                        disabled={exceptionText?.length > 0 ? false : true}
                        onClick={() => { setStoreExceptionCompletedClick() }}
                    >
                        {t('Save')}
                    </RACButton>
                </Grid>


            </>
        )
    }

    return (
        <Grid>
            <RACModalCard
                title={`${t('Enter Explanation For')} ${t(exceptionDescscription ? exceptionDescscription : exceptionDesc)} ${ language=='en'|| language=='es-US' ? t("Exception") : ''} `}
                isOpen={props.isopen == true || props.isopen == false ? props.isopen : storeExceptionPopup}
                closeIcon={true}
                maxWidth="sm"
                onClose={() => setStoreExceptionCancelClick()}
                borderRadius={"25px !important"}
                children={StoreExceptionPopup()}
            />



        </Grid>
    )
}
